var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "must-read", class: { "not-subscribe": _vm.notSubscribe } },
    [
      _c("div", { staticClass: "must-read__number" }, [
        _vm._v("\n    " + _vm._s(_vm.number) + "\n  "),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "must-read__title" },
        [
          _c("nuxt-link", {
            attrs: { to: _vm.link },
            domProps: { innerHTML: _vm._s(_vm.text) },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.notSubscribe ? _c("Tooltip") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }